 function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import styled from '@emotion/styled'
import React, {useMemo} from 'react'
import {commitLocalUpdate} from 'react-relay'
import useSearchFilter from '~/hooks/useSearchFilter'
import useAtmosphere from '../hooks/useAtmosphere'

import SearchQueryId from '../shared/gqlIds/SearchQueryId'
import Checkbox from './Checkbox'
import DropdownMenuLabel from './DropdownMenuLabel'
import {EmptyDropdownMenuItemLabel} from './EmptyDropdownMenuItemLabel'
import Menu from './Menu'
import MenuItem from './MenuItem'
import MenuItemHR from './MenuItemHR'
import MenuItemLabel from './MenuItemLabel'
import MockFieldList from './MockFieldList'
import {SearchMenuItem} from './SearchMenuItem'
import TypeAheadLabel from './TypeAheadLabel'

const StyledMenu = styled(Menu)({
  width: 250
})

const ProjectAvatar = styled('img')({
  height: 24,
  width: 24,
  marginRight: 8
})

const StyledCheckBox = styled(Checkbox)({
  marginLeft: -8,
  marginRight: 8
})

const UseJQLLabel = styled('span')({
  fontWeight: 600
})

const StyledMenuItemLabel = styled(MenuItemLabel)(({isDisabled}) => ({
  opacity: isDisabled ? 0.5 : undefined
}))

const FilterLabel = styled(DropdownMenuLabel)({
  borderBottom: 0
})




















const getValue = (item) => item.name

const MAX_PROJECTS = 10

// Reusable for both Jira and Jira Server.
const JiraScopingSearchFilterMenu = (props) => {
  const {menuProps, projects, meetingId, jiraSearchQuery, service} = props
  const isLoading = meetingId === null
  const projectKeyFilters = _nullishCoalesce(_optionalChain([jiraSearchQuery, 'optionalAccess', _ => _.projectKeyFilters]), () => ( []))
  const isJQL = _nullishCoalesce(_optionalChain([jiraSearchQuery, 'optionalAccess', _2 => _2.isJQL]), () => ( false))

  const {
    query,
    filteredItems: queryFilteredProjects,
    onQueryChange
  } = useSearchFilter(projects, getValue)

  const showSearch = projects.length > MAX_PROJECTS
  const selectedAndFilteredProjects = useMemo(() => {
    const selectedProjects = projects.filter((project) => projectKeyFilters.includes(project.id))
    const adjustedMax =
      selectedProjects.length >= MAX_PROJECTS ? selectedProjects.length + 1 : MAX_PROJECTS
    return Array.from(new Set([...selectedProjects, ...queryFilteredProjects])).slice(
      0,
      adjustedMax
    )
  }, [queryFilteredProjects])

  const atmosphere = useAtmosphere()
  const {portalStatus, isDropdown} = menuProps
  const toggleJQL = () => {
    commitLocalUpdate(atmosphere, (store) => {
      const searchQueryId = SearchQueryId.join(service, meetingId)
      const jiraSearchQuery = store.get(searchQueryId)
      // this might bork if the checkbox is ticked before the full query loads
      if (!jiraSearchQuery) return
      jiraSearchQuery.setValue(!isJQL, 'isJQL')
      jiraSearchQuery.setValue([], 'projectKeyFilters')
    })
  }
  return (
    React.createElement(StyledMenu, {
      keepParentFocus: true,
      ariaLabel: 'Define the Jira search query',
      portalStatus: portalStatus,
      isDropdown: isDropdown,
      resetActiveOnChanges: [selectedAndFilteredProjects],}

      , React.createElement(MenuItem, {
        key: 'isJQL',
        label: 
          React.createElement(MenuItemLabel, null
            , React.createElement(StyledCheckBox, { active: isJQL,} )
            , React.createElement(UseJQLLabel, null, 'Use JQL')
          )
        ,
        onClick: toggleJQL,}
      )
      , React.createElement(MenuItemHR, null )
      , isLoading && React.createElement(MockFieldList, null )
      , selectedAndFilteredProjects.length > 0 && React.createElement(FilterLabel, null, "Filter by project:"  )
      , showSearch && (
        React.createElement(SearchMenuItem, { placeholder: "Search Jira" , onChange: onQueryChange, value: query,} )
      )
      , (query && selectedAndFilteredProjects.length === 0 && !isLoading && (
        React.createElement(EmptyDropdownMenuItemLabel, { key: "no-results",}, "No Jira Projects found!"

        )
      )) ||
        null
      , selectedAndFilteredProjects.map((project) => {
        const {id: globalProjectKey, avatar, name} = project
        const toggleProjectKeyFilter = () => {
          commitLocalUpdate(atmosphere, (store) => {
            const searchQueryId = SearchQueryId.join(service, meetingId)
            const jiraSearchQuery = store.get(searchQueryId)
            const projectKeyFiltersProxy = jiraSearchQuery.getValue('projectKeyFilters').slice()
            const keyIdx = projectKeyFiltersProxy.indexOf(globalProjectKey)
            if (keyIdx !== -1) {
              projectKeyFiltersProxy.splice(keyIdx, 1)
            } else {
              projectKeyFiltersProxy.push(globalProjectKey)
            }
            jiraSearchQuery.setValue(projectKeyFiltersProxy, 'projectKeyFilters')
          })
        }
        return (
          React.createElement(MenuItem, {
            key: globalProjectKey,
            label: 
              React.createElement(StyledMenuItemLabel, { isDisabled: isJQL,}
                , React.createElement(StyledCheckBox, {
                  active: projectKeyFilters.includes(globalProjectKey),
                  disabled: isJQL,}
                )
                , React.createElement(ProjectAvatar, { src: avatar,} )
                , React.createElement(TypeAheadLabel, { query: query, label: name,} )
              )
            ,
            onClick: toggleProjectKeyFilter,
            isDisabled: isJQL,}
          )
        )
      })
    )
  )
}

export default JiraScopingSearchFilterMenu
